"use client";

import React from "react";

export default function TermsOfServiceAndPrivacyPolicyPage() { return ( <main className="max-w-3xl mx-auto p-6 space-y-8"> <section> <h1 className="text-2xl font-bold mb-2">Terms of Service</h1> <p className="text-sm text-muted-foreground mb-4"> Last Updated: Mar. 8, 2025 </p>
    <p className="mb-2">
      Welcome to SwimRecruit.ai! By accessing or using our website, you agree to be bound by these Terms of Service.
      If you do not agree, please do not use our services.
    </p>

    <h2 className="font-semibold mb-1 mt-4">1. General Information</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>The website provides swim performance data to help users assess college-level performances.</li>
      <li>The website is available globally with no age restrictions.</li>
      <li>Users must create an account and subscribe to access predictions and data.</li>
    </ul>

    <h2 className="font-semibold mb-1 mt-4">2. User Accounts &amp; Subscription</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>Users must register using an email and password.</li>
      <li>Payment processing is handled through Stripe.</li>
      <li>All subscription fees are non‑refundable. By subscribing, you acknowledge and agree that no refunds will be provided for any fees charged.</li>
      <li>Accounts may be terminated upon request.</li>
    </ul>

    <h2 className="font-semibold mb-1 mt-4">3. Data Collection &amp; Privacy</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>We collect email, gender, PR information, and college interests.</li>
      <li>Payment details are processed by Stripe.</li>
      <li>User passwords are encrypted and stored in Supabase.</li>
      <li>User data is stored indefinitely, even after account termination.</li>
      <li>We may comply with GDPR, CCPA, or other privacy regulations where applicable.</li>
      <li>Data used to create our products is proprietary information.</li>
    </ul>

    <h2 className="font-semibold mb-1 mt-4">4. No Guarantees &amp; Limitations of Liability</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>Prediction accuracy is not guaranteed; all data is for informational purposes only.</li>
      <li>We are not liable for any decisions made based on the predictions.</li>
      <li>Users cannot hold us accountable for training outcomes or missed opportunities.</li>
    </ul>

    <h2 className="font-semibold mb-1 mt-4">5. Third-Party Integrations</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>We integrate with Stripe for payments and Supabase for authentication.</li>
      <li>We may integrate with external APIs for athlete performance data.</li>
    </ul>

    <h2 className="font-semibold mb-1 mt-4">6. Account Suspension &amp; Termination</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>
        Grounds for account suspension or banning are currently undefined but may be enforced if needed.
      </li>
      <li>
        Users can contact support for disputes or issues.
      </li>
    </ul>

    <h2 className="font-semibold mb-1 mt-4">7. Changes to Terms</h2>
    <p className="mb-4">
      We do not plan to update these terms regularly, but changes may occur as necessary.
    </p>
  </section>

  <section>
    <h1 className="text-2xl font-bold mb-2">Privacy Policy</h1>
    <p className="text-sm text-muted-foreground mb-4">
      Last Updated: Mar. 8, 2025
    </p>

    <p className="mb-2">
      This Privacy Policy explains how we collect, use, and store user information.
    </p>

    <h2 className="font-semibold mb-1 mt-4">1. Information We Collect</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>Personal Information: Email, gender, PR information, and college interests.</li>
      <li>Payment Information: Collected and processed securely through Stripe.</li>
      <li>Authentication Data: Managed via Supabase with encrypted passwords.</li>
    </ul>

    <h2 className="font-semibold mb-1 mt-4">2. Data Usage</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>Used solely to provide users with performance insights and maintain accounts.</li>
      <li>No current plans to share data with third parties.</li>
      <li>No tracking cookies or analytics tools are used at this time.</li>
      <li>Data used to create our products is proprietary information.</li>
    </ul>

    <h2 className="font-semibold mb-1 mt-4">3. Data Retention &amp; Security</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>User data is stored indefinitely, even after account termination.</li>
      <li>We take security measures to protect stored information, including encryption for sensitive data.</li>
    </ul>

    <h2 className="font-semibold mb-1 mt-4">4. User Rights</h2>
    <ul className="list-disc pl-6 mb-4">
      <li>Users can terminate their accounts upon request.</li>
      <li>Data deletion requests are not currently supported.</li>
      <li>We may comply with GDPR, CCPA, or other applicable privacy laws.</li>
    </ul>

    <h2 className="font-semibold mb-1 mt-4">5. Contact Information</h2>
    <p className="mb-4">
      For questions or concerns, please reach out via our support email.
    </p>
  </section>

  <p className="text-sm text-muted-foreground">
    By using SwimRecruit.ai, you acknowledge that you have read and understood these terms and policies.
  </p>
</main>

); }